// Razorpay Configuration
// For production, move these to environment variables

export const RAZORPAY_CONFIG = {
  // Test Key for demo purposes
  // Replace this with your actual Razorpay test key from https://dashboard.razorpay.com/app/keys
  TEST_KEY: 'rzp_test_FELPeq7HeVvV2w', // This is a dummy key for demo
  
  // Production key (use environment variable in production)
  LIVE_KEY: process.env.REACT_APP_RAZORPAY_KEY || '',
  
  // Use test mode for demo
  USE_TEST_MODE: true,
  
  // Company details
  COMPANY_NAME: 'Almawakening',
  COMPANY_DESCRIPTION: 'Supporting communities through grassroots initiatives',
  
  // Theme customization
  THEME_COLOR: '#6366f1', // Match your brand color
  
  // Currency
  CURRENCY: 'INR',
  
  // Default prefill data for testing
  TEST_PREFILL: {
    name: 'Test Donor',
    email: 'test@example.com',
    contact: '9999999999',
  },
};

// Helper function to get the appropriate key
export const getRazorpayKey = (): string => {
  return RAZORPAY_CONFIG.USE_TEST_MODE 
    ? RAZORPAY_CONFIG.TEST_KEY 
    : RAZORPAY_CONFIG.LIVE_KEY;
};

export default RAZORPAY_CONFIG; 